var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containerRestart"},[_c('PlayerTuto',{attrs:{"text":_vm.textContent.consigne.player,"socket-send":"enigme2-readyRestart","text-button":"Recommencer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }